import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { ErrorProvider } from "./contexts/ErrorContext";
import { UserProvider } from "./contexts/UserContext";
import "./index.css";

const root = createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<Router>
			<ErrorProvider>
				<UserProvider>
					<App />
				</UserProvider>
			</ErrorProvider>
		</Router>
	</React.StrictMode>
);
